<template>
    <v-button label="Facebook" ico="ion-social-facebook" icoPosition="left" classe="button-dark btn-dark btn-facebook btn-block mb-3" @click="login"></v-button>
</template>

<script>
    import fb from 'facebook-login-promises'

    export default {
        data() {
            return {
                connected: false
            }
        },
        methods: {
            login() {
                this.$root.setLoading('Carregando perfil do Facebook', true)
                fb.callback.login({
                    appId: process.env.FACEBOOK_APP_ID
                }, (result) => {
                    if(result.status == "connected" && result.data && !this.connected){
                        this.connected = true
                        let data = {
                            name: result.data.first_name,
                            id: result.data.id,
                            type: 1,
                        }
                        this.$emit('login', data)
                    }
                })
            },
            logout() {
                location.reload()
            }
        },
    }
</script>

<style>
    .btn-facebook i{
        font-size: 1.3em;
    }
</style>


// WEBPACK FOOTER //
// src/components/SocialButtons/FacebookLogin.vue